import React, { useState, useCallback } from 'react';
import Paper from '@material-ui/core/Paper';
import TableBody from '@material-ui/core/TableBody';
import Table from '@material-ui/core/Table';

import UserStatisticReserveTableHead from './UserStatisticReserveTableHead';
import UserStatisticsReserveTableItem from './UserStatisticsReserveTableItem';
import { TReserve } from '../../../types/IBookingStore';
import { IBookingOrders } from '../../../types/IStatisticStore';
import Title from '../../Common/Title';
import locales from '../../../locales';
import TablePagination from "@material-ui/core/TablePagination";
import { useSelector } from "react-redux";

type Props = {
  reserves: Array<TReserve>;
  onChangeSort: (sort: "desc" | "asc") => void;
  bookingsOrders: IBookingOrders;
  onOpenBookingDetails: (bookingId: number) => void;
  moneySymbol: string;
  sortType: "desc" | "asc";
  page: number;
  pageSize: number;
  onChangePage: (page: number) => void;
  onChangePageSize: (pageSize: number) => void;
};

const index: React.FC<Props> = ({
  reserves,
  bookingsOrders,
  moneySymbol,
  sortType,
  page,
  pageSize,
  onOpenBookingDetails,
  onChangeSort,
  onChangePage,
  onChangePageSize,
}) => {
  const totalCount = useSelector((state: any) => state.userStatistics.totalCount);

  const handleChangeSortType = useCallback(() => {
    onChangeSort(sortType === 'desc' ? 'asc' : 'desc');
  }, [sortType]);

  const handleChangePage = (_, page) => {
    onChangePage(page)
  }

  const handleChangeRowsPerPage = (e) => {
    onChangePageSize(e.target.value)
  }

  return (
    <Paper elevation={3}>
      <Title
        padding="8px 12px 8px 24px"
        text={locales.t('statistics.reserves.title')}
        borderBottom
        spaceBetween
      />
      <Table>
        <UserStatisticReserveTableHead
          onRequestSort={handleChangeSortType}
          order={sortType}
          orderBy="date"
        />
        <TableBody>
          {
            reserves.map(reserve => (
              <UserStatisticsReserveTableItem
                key={reserve.id}
                reserveInfo={reserve}
                order={bookingsOrders[reserve.id]}
                handleOpenBookingDetails={onOpenBookingDetails}
                moneySymbol={moneySymbol}
              />
            ))
          }
        </TableBody>
      </Table>
      <TablePagination
        labelRowsPerPage="Строк на странице:"
        style={{ paddingRight: 8 }}
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalCount}
        rowsPerPage={pageSize}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default index;
